import { Directive, Provider } from '@angular/core';
import { AppContextDirective } from '@modules/common/directives/app-context.directive';
import { BaseAppStateService } from '@modules/common/services/base-app-state.service';
import { NotesAppStateService } from '../services/state.service';

@Directive({
  selector: '[appNotesAppContext]',
  standalone: true,
})
export class NotesAppContextDirective extends AppContextDirective {
  static readonly providers = [...BaseAppStateService.provideAs(NotesAppStateService)];

  protected getProviders(): Provider[] {
    return NotesAppContextDirective.providers;
  }
}
